<template>
  <div class="pro-list">
    <div class="pro-container">
      <a-table :pagination="false" :loading="tbLoading" :data-source="list" row-key="id">
        <a-table-column
            align="center"
            title="商品信息">
          <template slot-scope="row,item">
            <div class="pro-box">
              <img :src="item.bannerPicPath" alt="" class="pro-img">
              <p class="pro-name">{{ item.productTitle }}</p>
            </div>
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="商品分類"
            data-index="categoryName">
        </a-table-column>
        <a-table-column
            align="center"
            title="商品價格">
          <template slot-scope="row,item">
            <p class="red" v-if="item.priceStr">{{ item.priceStr }}</p>
            <p class="red" v-else>¥{{ (item.productPrice / 100).toFixed(2) }}元</p>
            <a-button v-if="item.skus.length" type="link" size="small" @click="lookSku(item)">查看规格</a-button>
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="商品库存"
            data-index="inventoryNum">
        </a-table-column>
        <a-table-column
            align="center"
            title="商品销量"
            data-index="sales">
        </a-table-column>
        <a-table-column
            align="center"
            title="权限限制">
          <template slot-scope="row,item">
            <p v-if="item.limit">
              <span v-if="item.limit.userType === 1">游客</span>
              <span v-if="item.limit.userType === 2">注册用户</span>
              <span v-if="item.limit.userType === 3">会员</span>
            </p>
            <p v-else>无限制</p>
            <!--                        <p v-if="item.limit && item.limit.userType === 3">-->
            <!--                            <span style="color:#ff3657;font-size: 12px;" v-for="(item,index) in item.limit.vipType" :key="index">{{item.vipDesc}}</span>-->
            <!--                        </p>-->
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="上架時間">
          <template slot-scope="row,item">
            {{ item.gmtCreated | trans-date }}
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="操作">
          <template slot-scope="row,item">
            <a-button size="small" @click="recommend(item)">移出推薦</a-button>
          </template>
        </a-table-column>
      </a-table>
      <a-modal
          title="商品SKU详情"
          :visible="showSku"
          :footer="null"
          @cancel="skuCancel"
      >
        <a-descriptions title="" bordered :column="1" size="small">
          <a-descriptions-item v-for="(item,index) in skuObj" :key="index" :label="item.skuDesc">
            库存：{{ item.inventoryNum }}<br>
            价格：{{ item.productPrice }}
          </a-descriptions-item>
        </a-descriptions>
      </a-modal>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showSku: false,
      skuObj:[],
      total: 0,
      tbLoading: false,
      list: [],
      para: {
        pageIndex: 1,
        pageSize: 8,
        productState: 20,
        categoryId: undefined,
        productTitle: undefined,
        recommendState: 1
      },
      categoryList: []
    }
  },
  methods: {
    recommend(item) {
      let self = this;
      this.$Confirm({
        title: '提示',
        content: '確定要将該商品移出推薦列表嗎？',
        onOk() {
          return new Promise((resolve, reject) => {
            self.$http({
              method: 'post',
              url: '/manager/product/update',
              data: {
                id: item.id,
                recommendState: -1
              }
            }).then(res => {
              self.$Message.success('操作成功');
              self.getList();
              resolve();
            }).catch(err => {
              reject()
            })
          })
        },
        onCancel() {
        },
      });
    },
    skuCancel() {
      this.skuObj.splice(0, this.skuObj.length)
      this.showSku = false;
    },
    lookSku(item) {
      this.skuObj.splice(0, this.skuObj.length)
      this.skuObj = JSON.parse(JSON.stringify(item.skus));
      this.showSku = true;
    },
    getList() {
      let self = this;
      self.$http({
        method: 'post',
        url: '/manager/product/list',
        data: this.para,
      }).then(res => {
        self.list = res.data && res.data.list ? res.data.list : []
        self.list.forEach(item => {
          if (item.skus.length) {
            let str = ''
            let arr = []
            item.skus.forEach(sub => {
              arr.push(sub.productPrice)
            })
            arr.sort(function (a, b) {
              return a - b;
            })
            console.log(arr)
            if (arr.length > 1) {
              str = `¥${(arr[0] / 100).toFixed(2)}元-¥${(arr[arr.length - 1] / 100).toFixed(2)}元`
            } else {
              str = `¥${(arr[0] / 100).toFixed(2)}元`
            }
            item.priceStr = str;
          }
        })
        self.total = res.data && res.data.totalRows ? res.data.totalRows : 0
      })
    },
  },
  created() {
    this.$emit('breadcrumbChange', ['商品管理', '已上架商品'])
    this.getList();
  },
}
</script>
<style lang="less">
.pro-list {
  .pro-container {
    padding: 20px;
  }

  .search-box {
    margin-bottom: 20px;
    overflow: hidden;

    .item {
      float: left;
      margin-right: 20px;

      .text {
        font-size: 14px;
        color: #333;
      }
    }
  }

  .red {
    color: #ff3657;
  }

  .pro-box {
    display: flex;

    .pro-img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      display: block;
      margin-right: 20px;
    }

    .pro-name {
      color: #333;
      text-align: left;
      font-size: 14px;
    }
  }
}
</style>